import type { Action as ReduxAction } from 'redux';
import { BATCH, type BatchAction } from 'redux-batched-actions';
import { Observable } from 'rxjs/Observable';
import { fg } from '@atlassian/jira-feature-gating';
import { PARENT_TYPE } from '@atlassian/jira-platform-field-config';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import { EpicPanelRefetchStore } from '@atlassian/jira-software-backlog-panel/src/services/epic-panel-refetch';
import { defaultRegistry } from '@atlassian/react-sweet-state';
import { REFRESH_DATA_REQUEST } from '../../state/actions/app';
import {
	type CardSetIndividualResponseSuccessAction,
	CARD_SET_INDIVIDUAL_REQUEST_SUCCESS,
} from '../../state/actions/card-set-request';
import { CARD_CREATE_SUCCESS } from '../../state/actions/cards/create';
import { CARD_DELETE_SUCCESS } from '../../state/actions/cards/delete';
import { CARDS_PARENT_SET_SUCCESS } from '../../state/actions/cards/parent';
import type { ActionsObservable } from '../../state/types';

const isCardSetIndividualResponse = (
	action: ReduxAction,
): action is CardSetIndividualResponseSuccessAction =>
	action.type === CARD_SET_INDIVIDUAL_REQUEST_SUCCESS;

const isBatchCardParentSetSuccess = (batchAction: BatchAction) =>
	batchAction.payload.some(
		(action) => isCardSetIndividualResponse(action) && action.payload.fieldId === PARENT_TYPE,
	);

const REFETCH_EPIC_PANEL_DEBOUNCE_MS = 500;
export const refetchEpicPanelEpic = (action$: ActionsObservable) =>
	action$
		.ofType(
			CARDS_PARENT_SET_SUCCESS,
			REFRESH_DATA_REQUEST,
			CARD_CREATE_SUCCESS,
			CARD_DELETE_SUCCESS,
			BATCH,
		)
		.debounceTime(REFETCH_EPIC_PANEL_DEBOUNCE_MS)
		.switchMap((action) => {
			if (action.type === BATCH && !isBatchCardParentSetSuccess(action)) {
				return Observable.empty<never>();
			}

			/**
			 * This action is only triggered by DnD into the epic panel, so we can directly call refetch
			 * there instead of waiting for the debounce.
			 *
			 * TODO: remove CARDS_PARENT_SET_SUCCESS from action list once FG is cleaned up
			 */
			if (action.type === CARDS_PARENT_SET_SUCCESS && fg('jsw_epic_panel_paginated_fetch')) {
				return Observable.empty<never>();
			}

			const epicPanelRefetchStoreInstance = defaultRegistry.getStore(EpicPanelRefetchStore);
			const { triggerEpicPanelRefetch } = epicPanelRefetchStoreInstance.actions;
			triggerEpicPanelRefetch();
			return Observable.empty<never>();
		});
